import { FC } from 'react';
import { Divider, Form, Table } from 'antd';
import { useForm } from '@/libs/antd/form';
import ANTD_DEFAULT_PROPS from '@/libs/antd/props';
import { OfficeObservationParetoReceivable } from '@/libs/fleet-api/services/types';
import { formatCurrency } from '@/libs/antd/formater';
import { useFBDHVisitReportApprovalPage } from './VisitReportApproval';

type VisitReporParetoReceivableForm = {
	lists: OfficeObservationParetoReceivable<'payload'>[];
};

const FBDHVisitReportParetoReceivable: FC = () => {
	const { officeObservation } = useFBDHVisitReportApprovalPage();
	const { warehouse } = officeObservation ?? {};
	const { form, fieldName } = useForm<VisitReporParetoReceivableForm>();

	return (
		<Form.Provider>
			<Form
				{...ANTD_DEFAULT_PROPS.FORM}
				form={form}
				initialValues={
					{
						lists: warehouse?.paretoReceivables ?? [],
					} as VisitReporParetoReceivableForm
				}
				style={{ marginBottom: 30 }}
			>
				<Form.Item
					name={fieldName(['lists'])}
					noStyle
				/>
				<Form.Item shouldUpdate>
					{({ getFieldsValue }) => {
						const values = getFieldsValue() as VisitReporParetoReceivableForm;
						const dataSource =
							values?.lists?.map((list, key?) => {
								return { ...list, key };
							}) ?? [];

						return (
							<Table
								bordered
								pagination={false}
								dataSource={dataSource}
								columns={[
									{
										title: 'No',
										render: (_, __, index) => index + 1,
										width: 1,
										align: 'center',
									},
									{
										title: 'Nama Bouwheer',
										render: (_, record) => record.bouwheerName ?? '-',
									},
									{
										title: 'Nama Pekerjaan',
										render: (_, record) => record.jobName ?? '-',
									},
									{
										title: 'No. Telp Perusahaan',
										render: (_, record) => record.phoneNumber ?? '-',
									},
									{
										title: 'Nilai Piutang (Rp)',
										render: (_, record) =>
											formatCurrency(record.receivableValue) ?? '-',
									},
									{
										title: 'Umur Piutang Terlama (Hari)',
										render: (_, record) => record.oldestReceivableAge ?? '-',
									},
									{
										title: 'Kendala (Jika Ada)',
										render: (_, record) => record.constraint ?? '-',
									},
								]}
							/>
						);
					}}
				</Form.Item>
				<Divider />
			</Form>
		</Form.Provider>
	);
};

export default FBDHVisitReportParetoReceivable;
